import { useEffect, useState } from "react";

const STORAGE_KEY = "platform.showFormulaTooltips";
const CHANGE_EVENT = "platform-settings-changed";

function read(): boolean {
    try {
        return localStorage.getItem(STORAGE_KEY) === "true";
    } catch {
        return false;
    }
}

function write(value: boolean): void {
    try {
        localStorage.setItem(STORAGE_KEY, value ? "true" : "false");
    } catch {
        // ignore quota / private mode
    }
    window.dispatchEvent(new Event(CHANGE_EVENT));
}

/** Browser-local preference (Super Admin UI); default off. */
export function useShowFormulaTooltips() {
    const [enabled, setEnabled] = useState(read);

    useEffect(() => {
        const sync = () => setEnabled(read());
        window.addEventListener("storage", sync);
        window.addEventListener(CHANGE_EVENT, sync);
        return () => {
            window.removeEventListener("storage", sync);
            window.removeEventListener(CHANGE_EVENT, sync);
        };
    }, []);

    const update = (value: boolean) => {
        write(value);
        setEnabled(value);
    };

    return { enabled, setEnabled: update };
}
